import { CurrencySymbol } from "../../../utils/enum";
import { customerRatesExpenseSideLabel } from "../../../utils/helpers";

export default function Expense({
  expenseType,
  description,
  amount,
  addedBy,
  isApproved,
  currency,
  attachment,
  isFromCounterOffer = false,
}) {
  return (
    <div className="flex items-center mt-4 justify-between">
      <p className="font-normal mr-2 normal-case">
        {attachment?.url && (
          <a
            href={attachment.url}
            download={attachment.fileName}
            target="_blank"
            rel="noopener noreferrer"
            title={attachment.fileName}
            className="hover:underline mr-1"
          >
            <i className="fa-solid fa-paperclip" style={{ color: "#0F40AE" }}></i>
          </a>
        )}
        <span className="">
          {expenseType === "TOOLS"
            ? "Tools"
            : expenseType === "MATERIAL"
            ? "Material"
            : expenseType === "TRAVEL"
            ? "Travel"
            : expenseType === "ALL"
            ? "All"
            : ""}
        </span>{" "}
        Expense{description?.trim() ? ` (${description})` : ""}
      </p>
      <div className="border-t border-dotted border-gray-500 flex-grow"></div>
      <div className="bg-[#F6F6F6] inline-flex items-center  ml-2 px-2 py-1 rounded-md whitespace-nowrap">
        <i
          className={`fa-solid ${isApproved ? "fa-check" : "fa-xmark"}  mr-2`}
        ></i>
        <p className="font-normal">
          {customerRatesExpenseSideLabel(addedBy, isFromCounterOffer)}:{" "}
          {CurrencySymbol[currency]}{" "}
          {amount}
        </p>
      </div>
    </div>
  );
}
